import React, { useState, useEffect } from 'react';
import { Row, Col, Toast } from "react-bootstrap";
import "../_scss/Toastify.scss";

export function Toastify(props) {
    const [show, setShow] = useState(false);


    useEffect(() => {
        setShow(props.show);
    }, [props.show]);

    function handleClose() {
        setShow(false);
        // props.dispatch({
        //     type: "REMOVE_NOTIFICATION",
        //     id: props.id
        // })
        props.removeMsg(props.errorMsg.id);
    }
    return (
        <Row className="toast-container">
            <Col xs={12}>
                <Toast show={show} onClose={handleClose} delay={props.errorMsg.delay?props.errorMsg.delay:2000} autohide className={props.errorMsg.type === "SUCCESS" ? "toast-success" : "toast-error"} >
                    <Toast.Header style={{ justifyContent: "space-between" }}>
                        <span>{props.errorMsg.type}</span>
                    </Toast.Header>
                    <Toast.Body>{props.errorMsg.message}</Toast.Body>
                </Toast>
            </Col>
        </Row>
    )
}
